<!-- 检查项 -->
<template>
    <div v-if="componentsData.type == 14">
        <div class="bg-div" :style="bgStyle">
            <div class="flex-sb">
                <div :style="titleStyle">
                    {{ componentsData.content.title }}
                </div>
                <div :style="titleStyle">
                    {{ componentsData.content.button_name }}
                </div>
            </div>
            <div class="mt8">
                <div
                    class="check-row"
                    v-for="(item, i) in componentsData.content.table_list"
                    :key="i"
                >
                    {{ item.value }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    computed: {
        titleStyle() {
            const content = this.componentsData.content;
            return {
                fontSize: `${content.title_size}px`,
                color: content.title_color,
            };
        },
        bgStyle() {
            const content = this.componentsData.content;
            const style = {};
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            const bgImg = content.bg_img || {};
            if (bgImg.picview && content.bg_value) {
                style.backgroundImage = `url(${bgImg.picview})`;
            }
            style.padding = `${content.inner_spacing.top}px ${content.inner_spacing.left}px`;
            style.margin = `${content.outer_spacing.top}px ${content.outer_spacing.left}px`;
            style.borderRadius = `${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.bottom}px ${content.rounded_corner_setting.bottom}px`;
            return style;
        },
    },
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.mt8 {
    margin-top: 8px;
}
.check-row {
    margin-bottom: 6px;
    padding: 6px;
    font-size: 14px;
    color: #333;
    border: 1px solid #ccc;
}
</style>
